interface IComment {
  name: string;
  message: string;
  onClick?: () => void;
}

const Comment = ({ name, message, onClick }: IComment) => {
  return (
    <div
      className={`bg-gray-50 rounded-lg p-4 mb-4 ${
        onClick ? 'cursor-pointer hover:bg-gray-100' : ''
      }`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }>
      <div>
        <p className="font-bold text-gray-800 capitalize">{name}</p>
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  );
};

export default Comment;
